var map = {
	"./components/PlayVideo.vue": 5552,
	"./components/VideoModal.vue": 4586,
	"./components/achievement.vue": 3425,
	"./components/age-consents.vue": 2216,
	"./components/hero-video.vue": 8883,
	"./components/language-dropdown.vue": 9017,
	"./components/lazy-image.vue": 5922,
	"./sections/full-image.vue": 8173,
	"./sections/hero-landing.vue": 9064,
	"./sections/image-text.vue": 2048,
	"./sections/level-timeline.vue": 4948,
	"./sections/levels-showcase.vue": 7642,
	"./sections/news.vue": 6011,
	"./sections/rte.vue": 4415,
	"./sections/testimonials.vue": 2261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5763;